import React from 'react';
import { ConfiguredWidgetsProps, WidgetProps } from '../../types';
import { getChartOptions } from '../../utils';
import { withSuspense } from '../hoc/withSuspense';
const DoughNutChart = React.lazy(() =>
  import('../widgets/DoughNutChartWidget')
);
const LineChart = React.lazy(() => import('../widgets/LineChartWidget'));
const MapWidget = React.lazy(() => import('../widgets/MapWidget'));
const CounterWidget = React.lazy(() => import('../widgets/CounterWidget'));
const ProgressWidget = React.lazy(() => import('../widgets/ProgressWidget'));
const ClockWidget = React.lazy(() => import('../widgets/ClockWidget'));
const AreaBumpWidget = React.lazy(() => import('../widgets/AreaBumpWidget'));
const ScatterPlotWidget = React.lazy(() =>
  import('../widgets/ScatterPlotWidget')
);
const PieChart = React.lazy(() => import('../widgets/PieChartWidget'));
const ChoroplethWidget = React.lazy(() =>
  import('../widgets/ChoroplethWidget')
);
const SunBurstWidget = React.lazy(() => import('../widgets/SunBurstWidget'));
const SwarmPlotWidget = React.lazy(() => import('../widgets/SwarmPlotWidget'));
const StreamWidget = React.lazy(() => import('../widgets/StreamWidget'));

export const getConfiguredWidgets = ({
  tokens,
  dataURLs,
}: ConfiguredWidgetsProps): WidgetProps[] => {
  return [
    {
      id: 'expense-report',
      name: 'Expense Report',
      component: withSuspense(DoughNutChart),
      data: { url: `${dataURLs.intermixApiUrl}/expense-report` },
      view: { ...getChartOptions() },
      options: { w: 3, h: 3 },
    },
    {
      id: 'scatter-plot',
      name: 'Scatter Plot Widget!',
      component: withSuspense(ScatterPlotWidget),
      data: {
        url: `${dataURLs.intermixApiUrl}/scatter-plot-report`,
      },
      sseUrl: dataURLs.intermixSseApiUrl,
      options: { w: 4, h: 3 },
    },
    {
      id: 'sun-burst',
      name: 'Sun Burst Widget',
      component: withSuspense(SunBurstWidget),
      data: { url: `${dataURLs.intermixApiUrl}/sun-burst-report` },
      options: {
        w: 3,
        h: 3,
      },
    },
    {
      id: 'swarm-plot',
      name: 'Swarm Plot Widget',
      component: withSuspense(SwarmPlotWidget),
      data: { url: `${dataURLs.intermixApiUrl}/swarm-plot-report` },
      options: {
        w: 4,
        h: 3,
      },
    },
    {
      id: 'stream-widget',
      name: 'Stream Widget',
      component: withSuspense(StreamWidget),
      data: { url: `${dataURLs.intermixApiUrl}/stream-report` },
      options: {
        w: 4,
        h: 3,
      },
    },
    {
      id: 'choropleth-widget',
      name: 'Country Wise Distribution',
      component: withSuspense(ChoroplethWidget),
      data: { url: `${dataURLs.intermixApiUrl}/geo-report` },
      options: {
        w: 4,
        h: 3,
        showName: false,
      },
    },
    {
      id: 'analytics-widget',
      name: 'Analytics Widget',
      component: withSuspense(PieChart),
      data: { url: `${dataURLs.intermixApiUrl}/analytics-report` },
      options: { w: 3, h: 3 },
    },
    {
      id: 'area-bump-widget',
      name: 'Area Bump Widget',
      component: withSuspense(AreaBumpWidget),
      data: { url: `${dataURLs.intermixApiUrl}/area-bump-report` },
      options: {
        w: 4,
        h: 3,
      },
    },
    {
      id: 'orders-by-day',
      name: 'Orders by day',
      component: withSuspense(LineChart),
      data: { url: `${dataURLs.intermixApiUrl}/orders-by-the-day` },
      options: { w: 4, h: 3 },
    },
    {
      id: 'issue-counter',
      name: 'Issue Counter',
      component: withSuspense(CounterWidget),
      data: { url: `${dataURLs.intermixApiUrl}/issues-report` },
      options: {
        title: 'Issues',
        titleClasses: {
          color: 'inherit',
        },
        valueClasses: {
          color: 'blue',
          size: '4rem',
        },
      },
    },
    {
      id: 'transport-map',
      name: 'Transport Map',
      component: withSuspense(MapWidget),
      security: {
        apiToken: tokens.mapboxApiToken,
      },
      data: { url: `${dataURLs.intermixApiUrl}/transport-map` },
    },
    {
      id: 'orders-complete',
      name: 'Orders Complete',
      component: withSuspense(ProgressWidget),
      data: { url: `${dataURLs.intermixApiUrl}/orders-complete` },
      options: {
        title: 'Orders Complete',
        titleClasses: {
          color: 'inherit',
          size: 'inherit',
        },
      },
    },
    {
      id: 'avg-load-time',
      name: 'Average Load Time',
      component: withSuspense(CounterWidget),
      data: { url: `${dataURLs.intermixApiUrl}/average-loadtime` },
      options: {
        title: 'Average Load Time',
        titleClasses: {
          color: 'inherit',
          size: '2rem',
        },
        valueClasses: {
          color: '#44337a',
          size: '4rem',
        },
      },
    },
    {
      id: 'clock-widget',
      name: 'Clock',
      component: withSuspense(ClockWidget),
      options: {
        titleClasses: {
          color: '#4a5568',
        },
        valueClasses: {
          color: '#c05621',
          size: '2rem',
        },
      },
    },
  ];
};
